import React from 'react';
import autobind from "autobind-decorator";
import { connect } from 'react-redux';

import services from 'core/services';
import { Row, Col, Button, Link, CardContent, Segmented } from 'core/components/Framework7';
import { PureComponent, GroupBox } from 'core/components';
import { withAuth } from 'core/decorators';
import { versionCodeToVersionNumber } from 'core/module/operations';
import classes from './styles.module.css';

class Update extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {}
  }

  update() {
    const { env } = this.props;
    const androidUrl = env ? env.apps ? env.apps.ios ? env.apps.android.currentVersion ? env.apps.android.currentVersion.storeUrl : null : null : null : null;
    const iosUrl = env ? env.apps ? env.apps.ios ? env.apps.ios.currentVersion ? env.apps.ios.currentVersion.storeUrl : null : null : null : null;

    if (cordova.platformId == "android") {
      navigator.app.loadUrl(androidUrl, { openExternal: true });
    } else if (cordova.platformId == "ios") {
      window.open(iosUrl, '_system');
    } else {
      window.open(iosUrl);
    }
  }

  renderChangesList() {
    const { updateVersion } = this.props;
    const changes = updateVersion.latestVersion.changed || []

    return changes.map((change, index) => {
      return this.renderChanges(change, index)
    })
  }

  renderChanges(change, index) {
    return (
      <Row key={index}>
        <Col>
          - {change}
        </Col>
      </Row>
    )
  }

  render() {
    const { updateVersion } = this.props;
    const { forceUpdateRequired, currentRelease, storeUrl } = updateVersion.latestVersion
    const { currentVersionNumber } = updateVersion

    const latestVersionNumber = versionCodeToVersionNumber(currentRelease)

    return (
      <div className={classes.container}>
        <div className={`${classes.pagePadding}`}>
          <GroupBox outline title='نسخه' className={classes.versionBox}>
            <CardContent>
              <Row className={classes.version}>
                <Col>
                  <span>{'نسخه نصب شده:'}</span>
                </Col>
                <Col>
                  <h2>{currentVersionNumber || "نامشخص"}</h2>
                </Col>
              </Row>
              <Row className={classes.version}>
                <Col>
                  <span>{'نسخه جدید:'}</span>
                </Col>
                <Col>
                  <h2>{latestVersionNumber}</h2>
                </Col>
              </Row>
            </CardContent>
          </GroupBox>
          <GroupBox outline title='فهرست تغییرات'>
            <CardContent>
              {this.renderChangesList()}
            </CardContent>
          </GroupBox>
        </div>

        <Segmented raised className={classes.fullWidth}>
          <Button large outline
            icon="mdi-cellphone-arrow-down"
            text={'بروزرسانی'}
            href={false}
            external
            target="_blank"
            className={`${classes.fullWidthButton}`}
            onClick={() => { window.open(storeUrl, '_system'); return false; }}
          />
          {!forceUpdateRequired &&
            <Button large outline
              icon={'mdi-chevron-left'}
              text={'ادامه'}
              className={`${classes.fullWidthButton}`}
              onClick={() => this.props.onSkipUpdate()}
            />
          }
        </Segmented>
      </div>
    )
  }
}

export default connect(
  state => ({
    env: state.General.env,
  }),
  {
  }
)(withAuth(autobind(Update)));
